import Money from 'js-money';
import {MoneyHelper} from "app/lib/moneyHelper";

export class Amount {
    constructor() {
        this.amount = null;
    }

    static create(amount) {
        return Object.assign(new Amount(), {amount});
    }

    static createMoney(amount, currency) {
        return Amount.create(new Money(amount, currency))
    }

    /** @private */
    _validTypeModel() {
        if (!(this.amount instanceof Money)) {
            throw Error('Amount is not instance of Money');
        }

        return this.amount instanceof Money;
    }

    get getAmount() {
        return this.amount.amount;
    }

    get getCurrency() {
        return this.amount.currency;
    }

    get toString() {
        if (!this._validTypeModel()) {
            return '';
        }

        return `${MoneyHelper.format(this.amount.amount)} ${this.amount.currency}`;
    }
}
